export enum Direction {
    Up,
    Down,
}